import { render, staticRenderFns } from "./ResultBestMatch.vue?vue&type=template&id=52be3b37&"
import script from "./ResultBestMatch.vue?vue&type=script&lang=js&"
export * from "./ResultBestMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports